import * as React from 'react';
import { Card, Button, Form, Icon } from 'tabler-react';
import toast from 'cogo-toast';
import PropTypes from 'prop-types';
import Request from '../../shared/request';

class Tips extends React.Component {
  saveNickname = async () => {
    const data = await Request.call('saveNickname', {
      nickname: this.props.nickname,
    });
    if (data && data.nickname) {
      toast.success('推荐昵称已变更');
    }
  };

  clearNickname = async () => {
    if (!this.props.affid) {
      toast.info('请等待审核通过');
      return;
    }
    const data = await Request.call('nickname', {
      nickname: '',
    });
    if (data && data.nickname === '') {
      this.props.updateState('nickname', '');
      toast.success('推荐昵称已清除');
    }
  };

  handleCopy = (event, key) => {
    if (!this.props.affid) {
      toast.info('请等待审核通过');
      return;
    }
    document.querySelector(`[name="copy-${key}"]`).select();
    const success = document.execCommand('copy');
    if (success) {
      toast.info('复制成功');
    } else {
      toast.warn('复制失败 请尝试手动复制');
    }
  };

  render() {
    return (
      <Card title="获取推广链接">
        <div className="aff-malus-link">
          <div className="link">
            <div className="item">
              <span className="label">购买页面分享链接</span>
              <Form.InputGroup>
                <Form.Input
                  readOnly
                  value={
                    this.props.affbuy
                      ? this.props.affbuy
                      : '审核通过后将生成专属推荐链接'
                  }
                  name="copy-buy"
                />
                <Form.InputGroupAppend>
                  <Button
                    RootComponent="button"
                    color="primary"
                    onClick={event => this.handleCopy(event, 'buy')}>
                    复制
                  </Button>
                </Form.InputGroupAppend>
              </Form.InputGroup>
            </div>

            <div className="item">
              <div className="label">
                设置昵称 <span>在推广页面展示 -为空则不显示</span>
                <span className="clear" onClick={() => this.clearNickname()}>
                  清除昵称
                  <Icon name="delete" />
                </span>
              </div>
              <Form.InputGroup>
                <Form.Input
                  placeholder={`${
                    this.props.affid ? '请输入自定义昵称' : '审核后可自定义昵称'
                  }`}
                  readOnly={!this.props.affid}
                  value={this.props.nickname}
                  onChange={e =>
                    this.props.affid &&
                    this.props.updateState('nickname', e.target.value)
                  }
                />
                <Form.InputGroupAppend>
                  <Button
                    RootComponent="button"
                    color="primary"
                    disabled={!this.props.affid ? 'disable' : ''}
                    onClick={() => this.saveNickname()}>
                    保存
                  </Button>
                </Form.InputGroupAppend>
              </Form.InputGroup>
            </div>
          </div>
          <div className="share-content">
            <div className="item">
              <div className="label">推荐分享文案 1</div>
              <div className={`content ${!this.props.affid ? 'disable' : ''}`}>
                <textarea
                  readOnly={!this.props.affid}
                  value={
                    this.props.shareText1
                      ? this.props.shareText1
                      : '审核通过后将生成专属推荐文案'
                  }
                  name="copy-shareText1"
                  onChange={e =>
                    this.props.updateState('shareText1', e.target.value)
                  }
                />
                <div
                  className="btn btn-copy"
                  onClick={event => this.handleCopy(event, 'shareText1')}>
                  复制
                </div>
              </div>
            </div>
            <div className="item">
              <div className="label">推荐分享文案 2</div>
              <div className={`content ${!this.props.affid ? 'disable' : ''}`}>
                <textarea
                  readOnly={!this.props.affid}
                  value={
                    this.props.shareText2
                      ? this.props.shareText2
                      : '审核通过后将生成专属推荐文案'
                  }
                  name="copy-shareText2"
                  onChange={e =>
                    this.props.updateState('shareText2', e.target.value)
                  }
                />
                <div
                  className="btn btn-copy"
                  onClick={event => this.handleCopy(event, 'shareText2')}>
                  复制
                </div>
              </div>
            </div>
          </div>

          <div className="download">
            <span className="label">Malus宣传素材下载</span>
            <div className="download-list">
              <a
                href="https://getmalus.com/r/aff-download-logo"
                target="_blank"
                rel="noopener noreferrer"
                className="item">
                <Icon name="download-cloud" />
                <span>品牌logo下载</span>
              </a>
              <a
                href="https://getmalus.com/r/aff-download-device"
                target="_blank"
                rel="noopener noreferrer"
                className="item">
                <Icon name="download-cloud" />
                <span>产品素材下载</span>
              </a>
              <a
                href="https://getmalus.com/r/aff-download-banner"
                target="_blank"
                rel="noopener noreferrer"
                className="item">
                <Icon name="download-cloud" />
                <span>宣传banner下载</span>
              </a>
            </div>
          </div>
        </div>
      </Card>
    );
  }
}

Tips.propTypes = {
  affid: PropTypes.string,
  nickname: PropTypes.string,
  shareText1: PropTypes.string,
  shareText2: PropTypes.string,
  updateState: PropTypes.func,
  affbuy: PropTypes.string,
};

export default Tips;
